// ZenPostDocStudioSection.jsx
// Cards identical to "Content AI Studio" (Platforms) section style.

import React from "react";
import { FaSitemap, FaFileAlt, FaShieldAlt, FaMagic } from "react-icons/fa";

const ZenPostDocStudioSection = ({
  badge = "Doc Studio",
  title = "Documentation & Data Room",
  subtitle = "ZenStudio erfasst zuerst Project Truth (Wizard + Scan) und generiert daraus verlässliche Dokumentation.",
  cards, // optional override
  sectionId = "docstudio",
  bgClassName = "bg-[transparent",
  ctaText = "Doc Studio öffnen",
  onCta,
}) => {
  const defaultCards = [
    {
      title: "Project Context",
      description:
        "Step 0: Vision, Zielgruppe, Nutzen & Business erfassen — als Source of Truth im Projektordner.",
      icon: <FaFileAlt />,
    },
    {
      title: "Project Analysis",
      description:
        "Automatic project structure detection — Ordnerrollen, Scripts, Dependencies, CI, Tests. Keine Vermutungen.",
      icon: <FaSitemap />,
    },
    {
      title: "Data Room",
      description:
        "Investor-ready Data Room — Index, Kapitel, Appendix. Fehlende Fakten werden als TODO markiert.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Templates",
      description:
        "Wiederverwendbare Dokument-Templates für Ton, Sprache & Struktur — Team-Standards inklusive.",
      icon: <FaMagic />,
    },
  ];

  const items = cards?.length ? cards : defaultCards;

  return (
    <section id={sectionId} className={`py-16 sm:py-20 px-4 ${bgClassName}`}>
      <div className="max-w-6xl mx-auto text-center">
        {/* Badge (same as Platforms) */}
        <div className="inline-flex items-center rounded-full border border-brand px-3 py-1 text-xs text-[#EFEBDC]">
          {badge}
        </div>

        {/* Title */}
        <h2 className="mt-4 text-2xl sm:text-4xl md:text-5xl font-extrabold text-brand">
          {title}
        </h2>

        {/* Subtitle */}
        <p className="mt-3 text-sm sm:text-lg text-[#EFEBDC] max-w-3xl mx-auto">
          {subtitle}
        </p>

        {/* Cards grid (IDENTICAL STYLE to Platforms) */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4 text-left">
          {items.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-brand  p-6 shadow-lg shadow-slate-950/40"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-transparent border border-brand text-brand text-xl">
                {item.icon}
              </div>

              <h3 className="mt-5 text-xl font-semibold text-brand">
                {item.title}
              </h3>

              <p className="mt-2 text-sm  text-[#EFEBDC]">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Optional single CTA under grid (clean, no extra box) */}
        {onCta && (
          <div className="mt-10">
            <button
              onClick={onCta}
              className="rounded-full border border-brand bg-slate-900 px-8 py-3 text-sm sm:text-base font-semibold text-brand shadow-lg shadow-brand/40 transition hover:shadow-brand/60"
            >
              {ctaText}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ZenPostDocStudioSection;
